<header runIn="desktop"></header>
<main id="main">
  <router-outlet />
</main>
<footer [code]="footerCode" [date]="footerDate" [year]="footerYear"></footer>
